import { render, staticRenderFns } from "./ResourceEmpty.vue?vue&type=template&id=23e0da35&scoped=true&"
import script from "./ResourceEmpty.vue?vue&type=script&lang=js&"
export * from "./ResourceEmpty.vue?vue&type=script&lang=js&"
import style0 from "./ResourceEmpty.vue?vue&type=style&index=0&id=23e0da35&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23e0da35",
  null
  
)

export default component.exports